import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { SocialIcons } from './SocialIcons';
import { footerLinks } from '../data/navigation';
import { business } from '../data/business';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy-900 pb-28 pt-16 lg:pb-12" data-id="element-27" data-mp="32m1aiwl92wnk">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:grid-cols-12 lg:px-8" data-id="element-28" data-mp="36ppn5toqoifo">
        <div className="md:col-span-5" data-id="element-29" data-mp="3ufjww2drhqvp">
          <Logo tone="light" className="h-20" data-id="element-30" data-mp="38qu4u3bljp2" />
          <p className="mt-6 font-display text-lg font-bold text-white" data-id="element-31" data-mp="37fu95czww38">{business.tagline}</p>
          <p className="mt-4 text-[15px] text-white/70" data-id="element-32" data-mp="3ldaphldsidmj">
            {business.city}
            <br data-id="element-33" data-mp="3qcnjcq32wkym" />
            Serving Central Florida
          </p>
          <div className="mt-6" data-id="element-34" data-mp="29z6v4e3aingy">
            <SocialIcons data-id="element-35" data-mp="29yxaz74xfaj6" />
          </div>
        </div>

        <nav aria-label="Footer" className="md:col-span-3" data-id="element-36" data-mp="2a1jkhcbdo041">
          <p className="text-sm font-semibold text-accent" data-id="element-37" data-mp="2ez1nkm2prl44">Navigation</p>
          <ul className="mt-4 space-y-3" data-id="element-38" data-mp="3l8qvi1vp0fqe">
            {footerLinks.map(l => <li key={l.href} data-id="element-39" data-mp="3gapd7j63ckfz">
                <a href={l.href} className="text-[15px] text-white/80 transition-colors duration-150 hover:text-white" data-id="element-40" data-mp="3gbr0qn4amzel">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="md:col-span-4" data-id="element-41" data-mp="3q7byua68rfj2">
          <p className="text-sm font-semibold text-accent" data-id="element-42" data-mp="82ie9xijwigy">Contact</p>
          <ul className="mt-4 space-y-3" data-id="element-43" data-mp="80nrednpyga8">
            <li data-id="element-44" data-mp="34p997szhui9">
              <a href={business.phoneHref} className="flex items-center gap-2.5 text-[15px] text-white/80 hover:text-white" data-id="element-45" data-mp="335u5kj2dpi2">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-46" data-mp="huwhyvt6vz5r" />
                {business.phoneDisplay}
              </a>
            </li>
            <li data-id="element-47" data-mp="qt067zvk7a19">
              <a href={`mailto:${business.email}`} className="flex items-center gap-2.5 text-[15px] text-white/80 hover:text-white" data-id="element-48" data-mp="qujm3pdazj2i">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="mtr8kjxees0f" />
                {business.email}
              </a>
            </li>
          </ul>
          <a href="#estimate" className="btn-primary mt-6 w-full sm:w-auto" data-id="element-50" data-mp="ytoa64vnsjyf">
            Get Your Free Estimate
          </a>
        </div>
      </div>
      <div className="mx-auto mt-14 max-w-7xl px-5 lg:px-8" data-id="element-51" data-mp="13rzjmei1ksg4">
        <p className="border-t border-white/10 pt-6 text-sm text-white/50" data-id="element-52" data-mp="18l2fitaakdzh">
          © {new Date().getFullYear()} {business.name}. All rights reserved.
        </p>
      </div>
    </footer>;
}